import React, {useContext} from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'

import {StateContext} from '../../utils/context'
import {_makeCapitalize} from '../../utils/helpers'

export default ({smallCategoryList, sticked}) => {
  const context = useContext(StateContext)

  const handleClickSmallCategory = (e) => {
    if (context.state.location.pathname.includes('/blogs')) {
      if (context.state.activeSmallCategory === e.target.id) return null
      context.dispatch({type: 'SelectSmallCategory', payload: {small: e.target.id}})
    } else {
      navigate('/blogs', {state: {large: context.state.activeLargeCategory, small: e.target.id}})
    }
  }


  if (!smallCategoryList) return null
  return (
    <Container className={sticked ? 'stick' : null}>
      {Object.keys(smallCategoryList).map(small => {
        return (
          <SmallCategory
            key={small}
            className={context.state.activeSmallCategory === small ? 'active' : null}
            onClick={handleClickSmallCategory}
            id={small}
          >
            {_makeCapitalize(small)}
            <SmallCount
              onClick={handleClickSmallCategory}
              id={small}
            >
              {`(${smallCategoryList[small]})`}
            </SmallCount>
          </SmallCategory>
        )
      })}
    </Container>
  )
}

const Container = styled.div`
  background-color: ${props => props.theme.beige};
  width: 100%;
  margin: 0 auto;
  height: 3rem;
  overflow: scroll;
  white-space: nowrap;
  display: flex;
  scrollbar-width: none;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
  position: sticky;
  top: calc(70px + 3rem);
  z-index: 10;
  &::-webkit-scrollbar {
    display: none;
  }
  &.stick {
    background-color: rgba(0, 0, 0, 0.7);
    color: #fff;
    & div {
      color: #fff;
    }
  }
  @media(min-width: 900px) {
    position: static;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 1rem;
    height: auto;
    transition: all 0.1s;
    &.stick {
      background-color: transparent;
    }
  }
`
const SmallCategory = styled.div`
  width: auto;
  color: ${props => props.theme.green};
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: baseline;
  font-weight: 300;
  transition: all 0.05s;
  cursor: pointer;
  &.active {
    font-weight: bold;
    font-size: 1.2rem;
  }
  @media(min-width: 900px) {
    margin-bottom: 1rem;
  }
`
const SmallCount = styled.div`
  width: auto;
  color: ${props => props.theme.green};
  font-size: 0.8rem;
  margin-right: 1.5rem;
  cursor: pointer;
  &.active {
    font-weight: bold;
  }
`